import IDataAccessObjectProperties from '../../../../core/DAL/DAO/IDataAccessObjectProperties';

export default class DistributionPermissionsDAOProperties extends IDataAccessObjectProperties {

	constructor() {
		let path = 'security/effective_permissions';
		let paramDefaults = {};
		let customActions = {
			getDestinationsEffectivePermissions: {
				method: 'POST',
                isArray: true
			}
		};

		super(path, paramDefaults, null, customActions);
	}
};

DistributionPermissionsDAOProperties.META = {
	name: 'DistributionPermissionsDAOProperties'
};



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/DAO/permissions/DistributionPermissionsDAOProperties.js